/**
 * Loading spinner-komponent
 */

import React from 'react';
import { RefreshCw } from 'lucide-react';

export const LoadingSpinner = () => {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <RefreshCw className="animate-spin text-orange-500 w-8 h-8" />
    </div>
  );
};
